import { c as _c } from "react/compiler-runtime";
import { useVillaTranslation } from "@website/accommodation-ui/villa-search/villa-search-panel/hooks/use-villa-translation";
import { VillaSearchNoResult } from "@website/accommodation-ui/villa-search/villa-search-panel/villa-search-no-result";
import { VillaSearchPanelPropertiesType } from "@website/accommodation-ui/villa-search/villa-search-panel/villa-search-panel.types";
import { useFetcher } from "@website/fetcher/use-fetcher";
import { useDebounce } from "@website/hooks/debounce";
import { MaterialIcon } from "@website/icons/material";
import pick from "lodash-es/pick";
import { useState } from "react";
export const useDestination = t0 => {
  const $ = _c(34);
  const {
    cityTitleInitialValues,
    searchAutocompleteFetcher,
    searchSuggestion
  } = t0;
  const [destinationQuery, setDestinationQuery] = useState("");
  const [selectedDestination, setSelectedDestination] = useState("");
  const [selectedDestinationItem, setSelectedDestinationItem] = useState(null);
  const query = useDebounce(destinationQuery, 250);
  const {
    translateEntity
  } = useVillaTranslation();
  let t1;
  if ($[0] !== query) {
    t1 = ["searchAutocomplete", query];
    $[0] = query;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = Boolean(query);
  let t3;
  if ($[2] !== searchAutocompleteFetcher) {
    t3 = t4 => {
      const {
        queryKey
      } = t4;
      return searchAutocompleteFetcher?.(queryKey[1]);
    };
    $[2] = searchAutocompleteFetcher;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      queryKey: t1,
      enabled: t2,
      queryFn: t3
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    isFetching,
    data
  } = useFetcher(t4);
  let t5;
  if ($[8] !== data || $[9] !== isFetching || $[10] !== query || $[11] !== searchSuggestion) {
    t5 = query && data && data.length > 0 ? data : searchSuggestion && !isFetching ? searchSuggestion : [];
    $[8] = data;
    $[9] = isFetching;
    $[10] = query;
    $[11] = searchSuggestion;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const destinationList = t5;
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = value => {
      setDestinationQuery(value);
    };
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const onChangeDestinationQuery = t6;
  let t7;
  if ($[14] !== destinationList || $[15] !== translateEntity) {
    t7 = destinationList?.map(item => ({
      ...pick(item, ["id", "title"]),
      subtitle: translateEntity(item.subtitle),
      StartIcon: item.isHotel ? <MaterialIcon name="hotel" variant="outlined" /> : <MaterialIcon name="trip_origin" variant="outlined" />,
      Meta: <div className="text-on-surface-high-emphasis text-caption">{item.info}</div>
    }));
    $[14] = destinationList;
    $[15] = translateEntity;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const destinationListNormalized = t7;
  let t8;
  if ($[17] !== destinationList) {
    t8 = id => {
      setSelectedDestination(id);
      const destinationItem = destinationList.find(destination => `${destination.id}` === `${id}`);
      setDestinationQuery("");
      setSelectedDestinationItem(destinationItem);
    };
    $[17] = destinationList;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const onSelectDestination = t8;
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = item_0 => {
      setSelectedDestination(item_0.id);
      setDestinationQuery("");
      setSelectedDestinationItem(item_0);
    };
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const onChangeDestination = t9;
  const t10 = selectedDestinationItem?.title || cityTitleInitialValues;
  let t11;
  if ($[20] !== data || $[21] !== destinationQuery || $[22] !== isFetching) {
    t11 = destinationQuery?.length >= 2 && !isFetching && data && data.length === 0 ? <VillaSearchNoResult query={destinationQuery} /> : undefined;
    $[20] = data;
    $[21] = destinationQuery;
    $[22] = isFetching;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== destinationList || $[25] !== destinationListNormalized || $[26] !== destinationQuery || $[27] !== isFetching || $[28] !== onSelectDestination || $[29] !== selectedDestination || $[30] !== selectedDestinationItem || $[31] !== t10 || $[32] !== t11) {
    t12 = {
      selectedDestinationItem,
      selectedDestinationText: t10,
      destinationQuery,
      selectedDestination,
      onChangeDestination,
      onSelectDestination,
      onChangeDestinationQuery,
      destinationList,
      destinationLoading: isFetching,
      destinationListNormalized,
      DestinationNoResult: t11
    };
    $[24] = destinationList;
    $[25] = destinationListNormalized;
    $[26] = destinationQuery;
    $[27] = isFetching;
    $[28] = onSelectDestination;
    $[29] = selectedDestination;
    $[30] = selectedDestinationItem;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  return t12;
};